import { Routes } from '@angular/router';
import { RoleGuard } from '@guards/role.guard';

const spmModule = () => import('./spm.module').then((m) => m.SpmModule);

export const spmRoutes: Routes = [
  {
    path: 'spm',
    canActivateChild: [RoleGuard],
    loadChildren: spmModule,
    data: {
      enum: 'SURAT_PERINTAH_MUAT',
      label: 'Surat Perintah Muat',
      icon: 'ic_spm_alt.svg',
      activeClass: 'active',
      children: [
        {
          enum: 'LIST_SPM_ALL',
          label: 'List SPM',
          path: 'spm/list',
          children: [],
        },
        {
          enum: 'LIST_SPM_BUTUH_DIPROSES',
          label: 'Menunggu Konfirmasi',
          path: 'spm/waiting-confirmation',
          children: [],
        },
        {
          enum: 'LIST_SPM_BUTUH_DIPROSES',
          label: 'Butuh Diproses',
          path: 'spm/created',
          children: [],
        },
        {
          enum: 'LIST_SPM_DIPROSES',
          label: 'Diproses',
          path: 'spm/pending',
          children: [],
        },
        {
          enum: 'LIST_SPM_HISTORY',
          label: 'Histori',
          path: 'spm/history',
          children: [],
        },
      ],
    },
  },
];
